import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { tasksQueriesKeys } from './constants.js'
import { userStatusOptions } from '../../../containers/tasks/constants.js'

/**
 * Fetches media parent data (post or task comment).
 * @param {string} projectId - ID of the project.
 * @param {string} search - Search param to use to search members.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - The query object with parent media data. The response includes a header 'dt-type'
 * that indicates whether the returned item is a media post or a media task comment, depending on where
 * the media is located.
 */

export const useGetProjectMembersQuery = (projectId, search = '', options) => {
  const fetchProjectMembers = async () => {
    const config = {
      method: 'GET',
      params: {
        size: 500,
        page: 0,
        sortBy: 'Name',
        sortDirection: 'ASC',
        company: 'All',
        search
      }
    }

    const { data } = await api(
      `/api/memberships-api/projects/${projectId}/members`,
      config
    )

    const members = data.content

    return members.filter(
      (member) =>
        member.membershipState !== userStatusOptions.REMOVED &&
        member.membershipState !== userStatusOptions.INACTIVE
    )
  }

  return useQuery({
    queryKey: [tasksQueriesKeys.GET_PROJECT_MEMBERS, projectId, search],
    queryFn: fetchProjectMembers,
    enabled: !!projectId,
    ...options
  })
}
